import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterFieldValue } from '../covance-filter.models';
import { CovanceFilterBaseType } from './covance-filter-base-type';
import { isEmpty, isNil, includes, uniqBy } from 'lodash';

@Injectable()
export class CovanceFilterSelectType extends CovanceFilterBaseType {
    constructor(router: Router, route: ActivatedRoute) {
        super(router, route);
    }

    public serializeValue(filterValue: any): string {
        return filterValue
                ? filterValue.value || filterValue.toString()
                : '';
    }

    public isMatch(fieldVal: FilterFieldValue, value: any) {
        return value === fieldVal.queryParamValue;
    }

    public setValue(fieldVal: FilterFieldValue) {
        if (isEmpty(fieldVal.items)) {
            return;
        }
        fieldVal.value = fieldVal.items.find((item: any) => { return (item && item.key) === fieldVal.queryParamValue; }) || fieldVal.queryParamValue || null;

        this.addSelectedValueToSource(fieldVal);
    }

    public setItems(fieldVal: FilterFieldValue, entities: any[]) {
        let data = fieldVal.def.getItems
            ? fieldVal.def.getItems(entities)
            : uniqBy(
                entities.map(entity => {
                    const item = entity[fieldVal.def.queryParam];

                    return item;
                }), 
                item => item && item.key || item);
        fieldVal.items = data;
        this.addSelectedValueToSource(fieldVal);
        this.changes.next(true);
        this.setValue(fieldVal);
    }


    public setQueryParamValue(fieldVal: FilterFieldValue) {
        fieldVal.queryParamValue = !isEmpty(fieldVal.value) ? fieldVal.value.key || fieldVal.value : null;
    }

    protected addSelectedValueToSource(fieldVal: FilterFieldValue) {
        if (isNil(fieldVal.value) || isEmpty(fieldVal.value)) {
            this.sortItems(fieldVal);
            return;
        }

        if (!fieldVal.items) {
            fieldVal.items.source = [fieldVal.value];
        } else {
            if (!includes(fieldVal.items, fieldVal.value)) {
                fieldVal.items.push(fieldVal.value);
            }
        }

        this.sortItems(fieldVal);
    }

    protected sortItems(fieldVal: FilterFieldValue) {
        if (!fieldVal.items) {
            return;
        }

        if (fieldVal.def.compare) {
            fieldVal.items.sort(fieldVal.def.compare);
        } else {
            fieldVal.items.sort();
        }
    }
}